var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 13.0105H0.191406V4.83472H2.73438V13.0105ZM1.44922 3.74097C0.65625 3.74097 0 3.05737 0 2.23706C0 1.11597 1.20312 0.405029 2.1875 0.979248C2.65234 1.22534 2.92578 1.71753 2.92578 2.23706C2.92578 3.05737 2.26953 3.74097 1.44922 3.74097ZM12.2227 13.0105H9.70703V9.04565C9.70703 8.08862 9.67969 6.8855 8.36719 6.8855C7.05469 6.8855 6.86328 7.89722 6.86328 8.96362V13.0105H4.32031V4.83472H6.75391V5.95581H6.78125C7.13672 5.3269 7.95703 4.64331 9.1875 4.64331C11.7578 4.64331 12.25 6.33862 12.25 8.52612V13.0105H12.2227Z",
    fill: "#1C2539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b963471d921b339120e2324b15ab4dd9.svg";
export { ForwardRef as ReactComponent };